import {
  ApplicationRoot,
  IntegratorRoot,
  ThemeProvider,
} from '@volkswagen-onehub/components-core';
import { FaContentServiceV1 } from '@volkswagen-onehub/fa-content-service';
import { FeatureappServiceV1 } from '@volkswagen-onehub/featureapp-service';
import { QueryClient, QueryClientProvider } from 'react-query';
import { default as localConfig } from './config/local';
import { default as localContent } from './content/local';
import TribalContext, {
  AppConfig,
  getTribalContextManagers,
} from './context/tribal';
import './global'; // Leave as first import
import AppRouteProvider from './router';
import { getPdbIdFromUrl } from './modules/utils/router';
import styled from 'styled-components';

interface AppProps {
  aemData: any;
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

function App(props: AppProps) {
  window.tb.logger.info(`${import.meta.env.VITE_APP_NAME} initialised`);

  const vwContentService = props?.aemData?.featureServices[
    'fa-content-service'
  ] as FaContentServiceV1;

  const featureAppService = props?.aemData?.featureServices[
    'featureapp-service'
  ] as FeatureappServiceV1;

  const aemContentData = vwContentService
    ? {
        ...props?.aemData?.config?.content,
        ...vwContentService.content,
      }
    : {};

  const aemConfigData = vwContentService
    ? {
        ...props?.aemData?.config?.config,
        // ...{
        //   exampleField: aemContentData.exampleField,
        // },
      }
    : {};

  const pdbId = getPdbIdFromUrl();

  const appConfig: AppConfig = {
    pdbId,
  };

  const {
    configManager,
    contentManager,
    analyticsManager,
    analyticsBuilder,
    retailerService,
    pdbService,
    productService,
    configurationService,
    stockService,
    imageService,
    agentService,
    carService,
    productFinanceService,
    financeService,
  } = getTribalContextManagers(
    aemConfigData,
    localConfig,
    aemContentData,
    localContent,
    featureAppService,
    appConfig
  );

  const PortalContainer = styled.div`
    position: absolute;
    z-index: 31;
  `;

  return (
    <ApplicationRoot>
      <IntegratorRoot>
        <ThemeProvider>
          <TribalContext.Provider
            value={{
              configManager,
              contentManager,
              analyticsManager,
              analyticsBuilder,
              retailerService,
              pdbService,
              productService,
              productFinanceService,
              financeService,
              carService,
              configurationService,
              stockService,
              imageService,
              agentService,
              appConfig,
            }}
          >
            <QueryClientProvider client={queryClient}>
              <PortalContainer id="portal-container"></PortalContainer>
              <AppRouteProvider />
            </QueryClientProvider>
          </TribalContext.Provider>
        </ThemeProvider>
      </IntegratorRoot>
    </ApplicationRoot>
  );
}

export default App;
